
import { Text } from '@mantine/core';
import Papa from 'papaparse';
import { logger } from 'utils/logger';

const CSVGenerator = ({
  data,
  filename,
  ignoreKeys='',
  label = 'Export to CSV',
  columns,
}) => {
  const exportToCSV = () => {
    const csvData = convertArrayToCSV(data);
    const blob = new Blob([csvData], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.style.display = 'none';
    a.href = url;
    a.download = `${filename}.csv`;
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
    document.body.removeChild(a);
  };

  function convertToEscapedCommas(inputString) {
    // Use a regular expression to replace commas with an escape character (e.g., backslash)
    const escapedString = inputString.replace(/,/g, '\\,');

    return escapedString;
  }

  function convertToOriginal(inputString) {
    // Use a regular expression to replace escaped commas with regular commas
    const originalString = inputString.replace(/\\,/g, ',');

    return originalString;
  }

  const convertArrayToCSV = (data) => {
    var keys = Object.keys(data[0]);

    const stringToRemove = ignoreKeys; // Comma-separated list to remove

    // Split the stringToRemove into an array of substrings
    const stringsToRemoveArray = stringToRemove
      .split(',')
      .map((str) => str.trim());

    // Use the filter() method to create a new array excluding the strings to remove
    var newArray = [];
    if(columns){
      newArray = columns;
    }else{
      newArray = keys.filter(
        (item) => !stringsToRemoveArray.includes(item)
      );
    }
    

    const tmpcsv = Papa.unparse(data, { columns: newArray });
    logger.log(tmpcsv);
    return tmpcsv;
    // return header + csv;
  };

  return (
    <div>
      <Text size='sm' fw={'600'} onClick={exportToCSV}>{label}</Text>
    </div>
  );
};

export default CSVGenerator;
